// extracted by mini-css-extract-plugin
module.exports = {"button":"PaginationButtons_button__gd2Ig","status":"PaginationButtons_status__3DM0c","prev":"PaginationButtons_prev__SuBk2","next":"PaginationButtons_next__2o5g1"};